import { useEffect, useState } from 'react';
import { text } from 'd3-fetch';

export default function HTMLPage(props) {

    const [page, setPage] = useState();

    useEffect(() => {
        let isMounted = true;
        text(`${props.prefix}${props.file}_${props.lang}.html`)
            .then(h => { if (isMounted) setPage(h); });
        return () => { isMounted = false }; 
    }, [props]);

    return <div dangerouslySetInnerHTML={{__html: page}} />;
}
